export default __webpack_public_path__ + "static/media/mask.6903e7e7.svg";